/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Flex_LabelInputs */

const en_us2_profile_editors_flex_label = /** @type {(inputs: Profile_Editors_Flex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`days with no set day`)
};

const pt_br2_profile_editors_flex_label = /** @type {(inputs: Profile_Editors_Flex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dias sem dia marcado`)
};

const es_419_profile_editors_flex_label = /** @type {(inputs: Profile_Editors_Flex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`días sin día fijo`)
};

const pt_pt2_profile_editors_flex_label = /** @type {(inputs: Profile_Editors_Flex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dias sem dia marcado`)
};

const fr_fr2_profile_editors_flex_label = /** @type {(inputs: Profile_Editors_Flex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jours sans jour fixé`)
};

const de_de2_profile_editors_flex_label = /** @type {(inputs: Profile_Editors_Flex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tage ohne festen Wochentag`)
};

const it_it2_profile_editors_flex_label = /** @type {(inputs: Profile_Editors_Flex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`giorni senza giorno fisso`)
};

/**
* | output |
* | --- |
* | "days with no set day" |
*
* @param {Profile_Editors_Flex_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_flex_label = /** @type {((inputs?: Profile_Editors_Flex_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Flex_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_flex_label(inputs)
	if (locale === "es-419") return es_419_profile_editors_flex_label(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_flex_label(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_flex_label(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_flex_label(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_flex_label(inputs)
	return en_us2_profile_editors_flex_label(inputs)
});
export { profile_editors_flex_label as "profile-editors.flex_label" }